module.exports = [
  // label for Y Axis
  'indexes.thousands',
  'indexes.millions',
  'indexes.billions',
  'indexes.barchart_yaxis.label_with_currency',
  'indexes.barchart_yaxis.label_without_currency',
];
